<template>
  <div class="all-proposals">
    <gov-header />
    <section v-if="$store.daoParameters !== null" class="section is-paddingless proposals-and-timelocks">
      <div class="columns is-centered">
        <div class="column is-three-fifths-desktop is-four-fifths-tablet">
          <div class="box info-box content">
            <h1 class="has-text-weight-medium">All Proposals</h1>
            <proposal-preview
              v-if="$store.daoParameters.poll !== null"
              :prop-number="$store.daoParameters.nextProposalId.minus(1).toNumber()"
              :override-prop-data="{poll: $store.daoParameters.poll, outcome: bigNumber(4)}"
            />
            <proposal-preview
              v-if="$store.daoParameters.timelockItem !== null"
              :prop-number="$store.daoParameters.timelockItem.id.toNumber()"
            />
            <proposal-preview :key="prop" v-for="prop in propPage" :prop-number="prop" />
            <div v-if="$store.daoParameters.nextProposalId.isEqualTo(1)" class="content">
              <p>There are no proposals in the DAO (yet!).</p>
              <router-link :to="{'name': 'Index'}" class="button is-primary">Return Home</router-link>
            </div>
            <div v-if="$store.daoParameters.nextProposalId.isGreaterThan(5)" class="content">
              <hr>
              <Pagination
                class="is-centered"
                :itemsTotal="$store.daoParameters.nextProposalId.toNumber()"
                :itemsPerPage="5"
                :currentPage="currentPage"
                :url="$route.name"
                :buttonsMax="5"
                queryParameter="page"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <div class="columns is-centered">
        <div class="column is-three-fifths-desktop is-four-fifths-tablet">
          <div class="box info-box content">
            <div class="loader-wrapper">
              <div class="loader is-large is-primary"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ProposalPreview from "@/components/ProposalPreview";
import _ from 'lodash'
import GovHeader from "@/components/GovHeader";
import Pagination from 'vue-bulma-paginate/src/components/Pagination';
import BigNumber from "bignumber.js";
export default {
  name: 'AllProposals',
  components: {GovHeader, ProposalPreview, Pagination},
  async mounted(){
    if (this.$route.query.page){
      this.currentPage = parseInt(this.$route.query.page)
    }
  },
  data(){
    return {
      networkLoading: false,
      currentPage: 1
    }
  },
  methods:{
    bigNumber(num){
      return new BigNumber(num)
    }
  },
  watch: {
    '$route.query.page': function (page) {
      this.currentPage = page
    }
  },
  computed: {
    propPage(){
      let rangeEnd = this.$store.daoParameters.nextProposalId
      if (this.$store.daoParameters.poll !== null){
        rangeEnd -= 1
      }
      if (this.$store.daoParameters.timelockItem !== null){
        rangeEnd -= 1
      }

      const chunks = _.chunk(_.range(0, rangeEnd).reverse(), 5)

      if (chunks.length > 0){
        return chunks[this.currentPage - 1]
      } else {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/sass/globals';
.all-proposals{
  .pagination-list, .content li + li{
    margin: 0;
  }
}

</style>
